/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Clear_ButtonInputs */

const en_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const fr_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer`)
};

const de_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

const it_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiaro`)
};

const ru_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачный`)
};

const es_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

const zh_cn2_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除`)
};

const ja_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア`)
};

const hi_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पष्ट`)
};

const pt_pt2_editor_clear_button = /** @type {(inputs: Editor_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Editor_Clear_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_clear_button = /** @type {((inputs?: Editor_Clear_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Clear_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_clear_button(inputs)
	if (locale === "de") return de_editor_clear_button(inputs)
	if (locale === "it") return it_editor_clear_button(inputs)
	if (locale === "ru") return ru_editor_clear_button(inputs)
	if (locale === "es") return es_editor_clear_button(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_clear_button(inputs)
	if (locale === "ja") return ja_editor_clear_button(inputs)
	if (locale === "hi") return hi_editor_clear_button(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_clear_button(inputs)
	return en_editor_clear_button(inputs)
});